export default "__VITE_ASSET__CmBQ0hgQ__"